var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "estate-base-info-tab y"
  }, [_c('el-tabs', {
    staticClass: "f-tabs",
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, _vm._l(_vm.tabs, function (item, index) {
    return _c('el-tab-pane', {
      key: item.component,
      attrs: {
        "label": item.name,
        "name": "".concat(index)
      }
    });
  }), 1), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "f-container"
  }, [_c(_vm.tabs[_vm.activeName].component, {
    tag: "component"
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }